import { hostQueryKeys as e } from "./useHostsQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { hostsApi as n } from "@maat/api-main";
//#region src/hosts/useHostListingGroupsQuery.ts
var r = (r, i) => {
	let a = t({
		queryKey: e.listingGroups(r, i),
		queryFn: () => n.getHostListingGroups(r, { perCity: i }),
		select: (e) => {
			let t = e.groups.map((e) => ({
				city: e.city,
				data: e.listings,
				total: e.total
			}));
			return {
				sections: t,
				total: t.reduce((e, t) => e + t.total, 0),
				cityCount: t.length
			};
		}
	});
	return {
		sections: a.data?.sections ?? [],
		total: a.data?.total ?? 0,
		cityCount: a.data?.cityCount ?? 0,
		isLoading: a.isLoading,
		isError: a.isError
	};
};
//#endregion
export { r as useHostListingGroupsQuery };
